import { React } from "react";
import classes from './Header.module.scss'
import HamburgerMenu from "./HamburgerMenu";


// MUI Imports
import Box from '@mui/material/Box';

function Header({ project,schema }) {

    return (
        <Box className={`${classes.Header}`}> 
            <Box className={`${classes.Header__container}`}>
                <section className={`${classes.Header__menu_container}`}>
                   {/* <img src={`${process.env.PUBLIC_URL}/assets/images/Menu.svg`} alt="Menu"/> */}
                   <HamburgerMenu schema={schema}/>
                </section>
                <section className={`${classes.Header__copy_container}`}>
                    <div dangerouslySetInnerHTML={{__html:`<h1>${schema.screenContent.header.heading}</h1>`}}></div>
                    <div dangerouslySetInnerHTML={{__html:`<h3>${schema.screenContent.header.subheading}</h3>`}}></div>
                </section>
                <section className={`${classes.Header__logo_container}`}>
                    <div className={`${classes.Header__logo_wrapper}`}>
                        <img src={`${process.env.PUBLIC_URL}/assets/images/logo-gain.svg`} alt="Gain Logo"/>
                    </div>
                </section>
            </Box>
        </Box>
    );
}
export default Header